export type Comparator<T> = (a: T, b: T) => 1 | 0 | -1

// find a first comparator, which returns 1 | -1, fallback to 0
// return a function that takes in (a,b) and can be used to sort arrays as is
//
// for example
// const cats = ['not-a-cat', 'cat']
// const sortA:Comparator<string> = (a,b) => a === 'not-a-cat' ? 1 : 0 // not-a-cats will go at the bottom
// const sortOrder = [
//    sortA, // if this returns 1 or -1, string compare is not used (results in grouped items in the array)
//    Comparators.gte
// ]
// cats.sort(compareConcat(sortOrder))
//
export const compareConcat =
  <T>(comparators: Comparator<T>[]) =>
  (a: T, b: T) =>
    comparators.find((p) => {
      return p(a, b) !== 0
    })?.(a, b) || 0

const gte: Comparator<string | number | boolean> = (a, b) => {
  if (a < b) {
    return -1
  }
  if (a > b) {
    return 1
  }

  return 0
}

export const Comparators = {
  gte,
}
